import React, { useEffect, useState, useRef } from 'react';
import { Button } from '../components/ui/Button';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { ColumnFilter } from '../components/ui/ColumnFilter';
// Mock data
const initialUsers = [{
  id: 1,
  nome: 'Monica',
  cognome: 'Ricci',
  email: 'filomena28@example.net',
  hasCandidature: false
}, {
  id: 2,
  nome: 'Brigitta',
  cognome: 'Galli',
  email: 'tazio.caruso@example.org',
  hasCandidature: true
}, {
  id: 3,
  nome: 'Fabrizio',
  cognome: 'Mariani',
  email: 'nico.valentini@example.org',
  hasCandidature: false
}, {
  id: 4,
  nome: 'Vittorio',
  cognome: 'Serra',
  email: 'ricci.pacifico@example.org',
  hasCandidature: false
}, {
  id: 5,
  nome: 'Priamo',
  cognome: 'Ferrari',
  email: 'xrinaldi@example.net',
  hasCandidature: true
}, {
  id: 6,
  nome: 'Valdo',
  cognome: 'Ferraro',
  email: 'ferri.paolo@example.net',
  hasCandidature: false
}, {
  id: 7,
  nome: 'Pierina',
  cognome: 'Pellegrino',
  email: 'bacchisio.monti@example.net',
  hasCandidature: false
}, {
  id: 8,
  nome: 'Michael',
  cognome: 'Admin',
  email: 'admin@perchicrea.it',
  hasCandidature: false,
  isCurrentUser: true
}];
interface TabView {
  id: string;
  name: string;
  filters: {
    nome: string;
    cognome: string;
    email: string;
  };
  searchQuery: string;
  rowsPerPage: number;
  currentPage: number;
}
const createDefaultTab = (id: string, name: string): TabView => ({
  id,
  name,
  filters: {
    nome: '',
    cognome: '',
    email: ''
  },
  searchQuery: '',
  rowsPerPage: 10,
  currentPage: 1
});
export function GestioneUtenti() {
  const [users, setUsers] = useState(initialUsers);
  // Tab System State
  const [tabs, setTabs] = useState<TabView[]>([createDefaultTab('tab-1', 'Tutti')]);
  const [activeTabId, setActiveTabId] = useState<string>('tab-1');
  const [editingTabId, setEditingTabId] = useState<string | null>(null);
  const [editTabName, setEditTabName] = useState('');
  const editInputRef = useRef<HTMLInputElement>(null);
  const activeTab = tabs.find(t => t.id === activeTabId) || tabs[0];
  const updateActiveTab = (updates: Partial<TabView>) => {
    setTabs(prev => prev.map(tab => tab.id === activeTabId ? {
      ...tab,
      ...updates
    } : tab));
  };
  const handleAddTab = () => {
    const newId = `tab-${Date.now()}`;
    const newName = `Vista ${tabs.length + 1}`;
    const newTab = createDefaultTab(newId, newName);
    setTabs([...tabs, newTab]);
    setActiveTabId(newId);
  };
  const handleRemoveTab = (e: React.MouseEvent, idToRemove: string) => {
    e.stopPropagation();
    if (tabs.length <= 1) return;
    const newTabs = tabs.filter(t => t.id !== idToRemove);
    setTabs(newTabs);
    if (activeTabId === idToRemove) {
      setActiveTabId(newTabs[newTabs.length - 1].id);
    }
  };
  const handleDoubleClickTab = (tab: TabView) => {
    setEditingTabId(tab.id);
    setEditTabName(tab.name);
  };
  const handleSaveTabName = () => {
    if (editingTabId && editTabName.trim()) {
      setTabs(prev => prev.map(tab => tab.id === editingTabId ? {
        ...tab,
        name: editTabName.trim()
      } : tab));
    }
    setEditingTabId(null);
  };
  const handleKeyDownTabName = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveTabName();
    } else if (e.key === 'Escape') {
      setEditingTabId(null);
    }
  };
  useEffect(() => {
    if (editingTabId && editInputRef.current) {
      editInputRef.current.focus();
      editInputRef.current.select();
    }
  }, [editingTabId]);
  // Modals State
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [deleteDialogState, setDeleteDialogState] = useState<{
    isOpen: boolean;
    userId: number | null;
    canDelete: boolean;
  }>({
    isOpen: false,
    userId: null,
    canDelete: true
  });
  const [newUser, setNewUser] = useState({
    nome: '',
    cognome: '',
    email: '',
    password: ''
  });
  const {
    filters,
    searchQuery,
    rowsPerPage,
    currentPage
  } = activeTab;
  // Filter logic
  const filteredData = users.filter(user => {
    const matchesSearch = user.nome.toLowerCase().includes(searchQuery.toLowerCase()) || user.cognome.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilters = user.nome.toLowerCase().includes(filters.nome.toLowerCase()) && user.cognome.toLowerCase().includes(filters.cognome.toLowerCase()) && user.email.toLowerCase().includes(filters.email.toLowerCase());
    return matchesSearch && matchesFilters;
  });
  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / rowsPerPage) || 1;
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const currentData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    updateActiveTab({
      filters: {
        ...filters,
        [key]: value
      },
      currentPage: 1
    });
  };
  const handleAddUser = () => {
    const newId = Math.max(...users.map(u => u.id)) + 1;
    const user = {
      id: newId,
      ...newUser,
      hasCandidature: false
    };
    setUsers([user, ...users]);
    setIsAddModalOpen(false);
    setNewUser({
      nome: '',
      cognome: '',
      email: '',
      password: ''
    });
  };
  const handleDeleteClick = (user: (typeof initialUsers)[0]) => {
    setDeleteDialogState({
      isOpen: true,
      userId: user.id,
      canDelete: !user.hasCandidature
    });
  };
  const confirmDelete = () => {
    if (deleteDialogState.userId) {
      setUsers(users.filter(u => u.id !== deleteDialogState.userId));
      setDeleteDialogState({
        isOpen: false,
        userId: null,
        canDelete: true
      });
    }
  };
  return <div className="space-y-6" data-id="element-1300">
      {/* Header Card */}
      <div className="bg-white p-6 flex justify-between items-center" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-1301">
        <h1 className="text-2xl font-normal text-navy-primary font-roboto m-0" data-id="element-1302">
          Gestione Utenti - {activeTab.name}
        </h1>
        <Button variant="primary" onClick={() => setIsAddModalOpen(true)} className="flex items-center gap-2" data-id="element-1303">
          <Icon icon="tabler:plus" fontSize={16} data-id="element-1304" />
          Aggiungi utente
        </Button>
      </div>

      {/* Tab Bar Workspace */}
      <div className="bg-white flex items-center overflow-x-auto" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '0 32px'
    }} data-id="element-1305">
        <div className="flex items-end gap-2 pt-2" data-id="element-1306">
          {tabs.map(tab => {
          const isActive = tab.id === activeTabId;
          const isEditing = tab.id === editingTabId;
          return <div key={tab.id} onClick={() => setActiveTabId(tab.id)} onDoubleClick={() => handleDoubleClickTab(tab)} className="group flex items-center gap-2 relative transition-colors" style={{
            padding: '14px 16px',
            paddingBottom: '12px',
            cursor: 'pointer',
            color: isActive ? '#293B54' : '#80858E',
            borderBottom: isActive ? '2px solid #2A97DF' : '2px solid transparent',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '15px',
            fontWeight: isActive ? 500 : 400,
            marginBottom: '-1px'
          }} data-id="element-1307">
                {isEditing ? <input ref={editInputRef} type="text" value={editTabName} onChange={e => setEditTabName(e.target.value)} onBlur={handleSaveTabName} onKeyDown={handleKeyDownTabName} style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontSize: '15px',
              fontWeight: 500,
              color: '#293B54',
              border: 'none',
              outline: 'none',
              background: 'transparent',
              width: `${Math.max(editTabName.length * 9, 60)}px`,
              padding: 0
            }} data-id="element-1308" /> : <span className="select-none whitespace-nowrap" data-id="element-1309">
                    {tab.name}
                  </span>}

                {tabs.length > 1 && !isEditing && <button onClick={e => handleRemoveTab(e, tab.id)} className={`flex items-center justify-center rounded-full p-0.5 transition-colors ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} style={{
              color: '#AAAAAA',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer'
            }} onMouseEnter={e => e.currentTarget.style.color = '#EA5455'} onMouseLeave={e => e.currentTarget.style.color = '#AAAAAA'} aria-label="Chiudi vista" data-id="element-1310">
                    <Icon icon="tabler:x" fontSize={14} data-id="element-1311" />
                  </button>}
              </div>;
        })}

          <button onClick={handleAddTab} className="flex items-center gap-1 transition-colors mb-2 ml-2" style={{
          padding: '8px 12px',
          color: '#AAAAAA',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          borderRadius: '4px'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F5F5F5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-1312">
            <Icon icon="tabler:plus" fontSize={14} data-id="element-1313" />
            Nuova vista
          </button>
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-white overflow-hidden" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-1314">
        {/* Toolbar */}
        <div className="p-4 border-b border-gray-200 flex items-center gap-4 bg-white" data-id="element-1315">
          <div className="relative w-[300px]" data-id="element-1316">
            <Icon icon="tabler:search" fontSize={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1317" />
            <input type="text" placeholder="Cerca utenti..." value={searchQuery} onChange={e => updateActiveTab({
            searchQuery: e.target.value
          })} className="w-full h-9 pl-9 pr-3 border border-gray-200 text-sm font-roboto focus:outline-none focus:border-navy-primary bg-white" data-id="element-1318" />
          </div>
          <button className="h-9 w-9 flex items-center justify-center border border-gray-200 text-gray-500 hover:bg-gray-50 bg-white rounded-full" data-id="element-1319">
            <Icon icon="tabler:columns" fontSize={16} data-id="element-1320" />
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-1321">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-1322">
            <thead data-id="element-1323">
              <tr className="border-b border-gray-200" style={{
              backgroundColor: '#FFFFFF'
            }} data-id="element-1324">
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[200px]" data-id="element-1325">
                  <ColumnFilter label="Nome" value={filters.nome} onChange={v => handleFilterChange('nome', v)} placeholder="Filtra nome..." data-id="element-1326" />
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[200px]" data-id="element-1327">
                  <ColumnFilter label="Cognome" value={filters.cognome} onChange={v => handleFilterChange('cognome', v)} placeholder="Filtra cognome..." data-id="element-1328" />
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider" data-id="element-1329">
                  <ColumnFilter label="Email" value={filters.email} onChange={v => handleFilterChange('email', v)} placeholder="Filtra email..." data-id="element-1330" />
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[120px]" data-id="element-1331">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1332">
              {currentData.map(row => <tr key={row.id} className="border-b border-gray-100 hover:bg-blue-50 transition-colors" data-id="element-1333">
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1334">
                    {row.nome}
                  </td>
                  <td className="p-4 text-sm font-roboto text-[#8C919A]" data-id="element-1335">
                    {row.cognome}
                  </td>
                  <td className="p-4 text-sm text-[#8C919A] font-roboto" data-id="element-1336">
                    {row.email}
                  </td>
                  <td className="p-4 text-center" data-id="element-1337">
                    {!row.isCurrentUser && <div className="flex items-center justify-center gap-1" data-id="element-1338">
                        <Link to={`/gestione-utenti/dettaglio/${row.id}`} className="p-1.5 text-gray-400 hover:text-navy-primary hover:bg-gray-100 rounded transition-colors inline-flex" data-id="element-1339">
                          <Icon icon="tabler:eye" fontSize={18} data-id="element-1340" />
                        </Link>
                        <button onClick={() => handleDeleteClick(row)} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors" data-id="element-1341">
                          <Icon icon="tabler:trash" fontSize={18} data-id="element-1342" />
                        </button>
                      </div>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex items-center justify-end gap-4 text-sm text-gray-600" data-id="element-1343">
          <div className="flex items-center gap-2" data-id="element-1344">
            <span data-id="element-1345">Righe per pagina:</span>
            <select value={rowsPerPage} onChange={e => updateActiveTab({
            rowsPerPage: Number(e.target.value),
            currentPage: 1
          })} className="border-none bg-transparent font-medium focus:outline-none cursor-pointer" data-id="element-1346">
              <option value={10} data-id="element-1347">10</option>
              <option value={25} data-id="element-1348">25</option>
              <option value={50} data-id="element-1349">50</option>
            </select>
          </div>
          <span data-id="element-1350">
            {startItem}-{endItem} di {totalItems}
          </span>
          <div className="flex items-center gap-1" data-id="element-1351">
            <button onClick={() => updateActiveTab({
            currentPage: Math.max(1, currentPage - 1)
          })} disabled={currentPage === 1} className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" data-id="element-1352">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-1353" />
            </button>
            <button onClick={() => updateActiveTab({
            currentPage: Math.min(totalPages, currentPage + 1)
          })} disabled={currentPage === totalPages || totalItems === 0} className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" data-id="element-1354">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-1355" />
            </button>
          </div>
        </div>
      </div>

      {/* Add User Modal */}
      {isAddModalOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1356">
          <div className="bg-white w-[500px] shadow-xl" style={{
        borderRadius: '8px',
        overflow: 'hidden'
      }} data-id="element-1357">
            <div className="p-6 border-b border-gray-200 flex justify-between items-center" data-id="element-1358">
              <h2 className="text-xl font-roboto text-navy-primary m-0" data-id="element-1359">
                Aggiungi Utente
              </h2>
              <button onClick={() => setIsAddModalOpen(false)} className="text-gray-400 hover:text-gray-600" data-id="element-1360">
                <Icon icon="tabler:x" fontSize={24} data-id="element-1361" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-1362">
              <div className="grid grid-cols-2 gap-4" data-id="element-1363">
                <div data-id="element-1364">
                  <label className="block text-sm text-gray-600 mb-1 font-roboto" data-id="element-1365">
                    Nome
                  </label>
                  <input type="text" value={newUser.nome} onChange={e => setNewUser({
                ...newUser,
                nome: e.target.value
              })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary font-roboto" data-id="element-1366" />
                </div>
                <div data-id="element-1367">
                  <label className="block text-sm text-gray-600 mb-1 font-roboto" data-id="element-1368">
                    Cognome
                  </label>
                  <input type="text" value={newUser.cognome} onChange={e => setNewUser({
                ...newUser,
                cognome: e.target.value
              })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary font-roboto" data-id="element-1369" />
                </div>
              </div>
              <div data-id="element-1370">
                <label className="block text-sm text-gray-600 mb-1 font-roboto" data-id="element-1371">
                  Email
                </label>
                <input type="email" value={newUser.email} onChange={e => setNewUser({
              ...newUser,
              email: e.target.value
            })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary font-roboto" data-id="element-1372" />
              </div>
              <div data-id="element-1373">
                <label className="block text-sm text-gray-600 mb-1 font-roboto" data-id="element-1374">
                  Password
                </label>
                <input type="password" value={newUser.password} onChange={e => setNewUser({
              ...newUser,
              password: e.target.value
            })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary font-roboto" data-id="element-1375" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3 bg-gray-50" data-id="element-1376">
              <Button variant="outlined" onClick={() => setIsAddModalOpen(false)} data-id="element-1377">
                Annulla
              </Button>
              <Button variant="primary" onClick={handleAddUser} data-id="element-1378">
                Crea utente
              </Button>
            </div>
          </div>
        </div>}

      {/* Delete Confirmation Dialog */}
      {deleteDialogState.isOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1379">
          <div className="bg-white w-[450px] shadow-xl p-6" style={{
        borderRadius: '8px'
      }} data-id="element-1380">
            <div className="flex items-start gap-4 mb-4" data-id="element-1381">
              <div className="p-2 bg-red-100 rounded-full text-red-600" data-id="element-1382">
                <Icon icon="tabler:alert-triangle" fontSize={24} data-id="element-1383" />
              </div>
              <div data-id="element-1384">
                <h3 className="text-lg font-medium text-navy-primary mb-2 font-roboto" data-id="element-1385">
                  {deleteDialogState.canDelete ? 'Elimina Utente' : 'Impossibile eliminare'}
                </h3>
                <p className="text-gray-600 text-sm font-roboto leading-relaxed" data-id="element-1386">
                  {deleteDialogState.canDelete ? 'Sei sicuro di voler eliminare questo utente? Questa azione non può essere annullata.' : 'Impossibile eliminare questo utente perché ha già presentato delle candidature. È necessario prima revocare o eliminare le candidature associate.'}
                </p>
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-6" data-id="element-1387">
              <Button variant="outlined" onClick={() => setDeleteDialogState({
            isOpen: false,
            userId: null,
            canDelete: true
          })} data-id="element-1388">
                {deleteDialogState.canDelete ? 'Annulla' : 'Chiudi'}
              </Button>
              {deleteDialogState.canDelete && <Button variant="primary" onClick={confirmDelete} className="bg-red-600 hover:bg-red-700 focus:ring-red-600 border-transparent" data-id="element-1389">
                  Elimina
                </Button>}
            </div>
          </div>
        </div>}
    </div>;
}